import { api } from "api/apiService";

/**
 * Надсилає запит на авторизацію користувача.
 * @param {string} usernameOrEmail - Ім'я користувача або електронна пошта.
 * @param {string} password - Пароль користувача.
 * @returns {Promise<object>} Проміс, що повертає дані авторизації (напр., токени доступу).
 */
export const loginUser = (usernameOrEmail, password) => {
  return api.post("/auth/login", { usernameOrEmail, password });
};

/**
 * Надсилає Google ID Token на бекенд для авторизації через Google.
 * @param {string} idToken - Google ID Token, отриманий від Google Identity Services.
 * @returns {Promise<object>} Проміс, що повертає дані авторизації (token, user).
 */
export const googleLogin = (idToken) => {
  return api.post("/auth/google", { idToken });
};
